import { render, staticRenderFns } from "./CollectionDetailed.vue?vue&type=template&id=6abfc1c1&scoped=true"
import script from "./CollectionDetailed.vue?vue&type=script&lang=js"
export * from "./CollectionDetailed.vue?vue&type=script&lang=js"
import style0 from "./CollectionDetailed.vue?vue&type=style&index=0&id=6abfc1c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abfc1c1",
  null
  
)

export default component.exports